"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameModel = exports.GameModelEvent = void 0;
const APIEventSystem_1 = require("@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem");
const Logger_1 = require("@nolimitcity/slot-launcher/bin/utils/Logger");
/**
 * Created by Jonas Wålekvist on 2020-09-07.
 */
var GameModelEvent;
(function (GameModelEvent) {
    GameModelEvent["INIT"] = "INIT";
    GameModelEvent["GAME"] = "GAME";
})(GameModelEvent || (exports.GameModelEvent = GameModelEvent = {}));
class GameModel {
    onInit(data) {
        this.initData = data;
        this.data = data;
        this.logger.log("INIT DATA", data);
        if (this.events) {
            this.events.trigger(GameModelEvent.INIT, data);
        }
    }
    ;
    onGame(data) {
        this.gameData = data;
        this.data = data;
        this.logger.log("GAME DATA", data);
        if (this.events) {
            this.events.trigger(GameModelEvent.GAME, data);
        }
    }
    ;
    constructor(api, triggerEvents = true) {
        if (triggerEvents) {
            this.events = api.eventSystemFactory.create();
        }
        this.logger = Logger_1.Logger.createNamedLogger("GameModel");
        api.events.on(APIEventSystem_1.APIEvent.INIT, (data) => this.onInit(data));
        api.events.on(APIEventSystem_1.APIEvent.GAME, (data) => this.onGame(data));
    }
}
exports.GameModel = GameModel;
//# sourceMappingURL=GameModel.js.map